import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { HousingUnitShowPage } from './housing-unit-show';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
	declarations: [
		HousingUnitShowPage,
	],
	imports: [
		ComponentsModule,
		IonicPageModule.forChild(HousingUnitShowPage),
	],
})
export class HousingUnitShowPageModule {}



// WEBPACK FOOTER //
// ./src/pages/housing-unit-show/housing-unit-show.module.ts